import { ref, computed } from "vue";
import { useRoomStore } from "../../../stores/room.mjs";
import { storeToRefs } from "pinia";
import { TUIRole } from "@tencentcloud/tuiroom-engine-js";
const showUserId = ref("");
function useMemberItem(userInfo) {
  const roomStore = useRoomStore();
  const { isMaster, isAdmin } = storeToRefs(roomStore);
  const isCanOperateCurrentMember = computed(() => {
    const isTargetUserRoomOwner = userInfo.userRole === TUIRole.kRoomOwner;
    const isTargetUserGeneral = userInfo.userRole === TUIRole.kGeneralUser;
    const isTargetUserMySelf = userInfo.userId === roomStore.localUser.userId;
    return isMaster.value && !isTargetUserRoomOwner || isAdmin.value && isTargetUserGeneral || isTargetUserMySelf;
  });
  const isCanOperateMySelf = computed(() => {
    return userInfo.userId === roomStore.localUser.userId;
  });
  const isMemberControlAccessible = computed(
    () => userInfo.userId === showUserId.value && (isCanOperateMySelf.value || isCanOperateCurrentMember.value)
  );
  function openMemberControl() {
    showUserId.value = userInfo.userId;
  }
  function closeMemberControl() {
    showUserId.value = "";
  }
  return {
    isMemberControlAccessible,
    openMemberControl,
    closeMemberControl,
    isCanOperateMySelf
  };
}
export {
  useMemberItem as default
};
